import { get, wrap } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import GeofencingShopSelectorContainer from 'containers/GeofencingShopSelectorContainer';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';
import Settings from 'utils/Settings';

const GeofencingController = class {
  static mountGeofencingShopSelectorContainer(store) {
    ReactDOM.render(
      <Provider store={store}>
        <GeofencingShopSelectorContainer />
      </Provider>,
      document.getElementById('geofencing-shop-selector-container')
    );
  }

  static handleGeofencingStateChange(store) {
    const state = store.getState();
    const suggestAlternativeShop = get(state, ['geofencing', 'suggestAlternativeShop']);
    const isOpen = get(state, ['app', 'modal']) === MODAL_TYPES.GEOFENCING_SHOP_SELECTOR;

    if (suggestAlternativeShop && !isOpen) {
      store.dispatch(actions.openGeofencingShopSelector());
    }
  }

  static subscribeGeofencingShopSelector(store) {
    const handler = wrap(store, GeofencingController.handleGeofencingStateChange);

    store.subscribe(handler);
  }

  static fetchGeofencingData(store) {
    store.dispatch(actions.fetchGeofencingData());
  }

  static init = async store => {
    if (Settings.geofencingEnabled) {
      GeofencingController.mountGeofencingShopSelectorContainer(store);
      GeofencingController.subscribeGeofencingShopSelector(store);
      GeofencingController.fetchGeofencingData(store);
    }
  };
};

export default GeofencingController;
